export default __webpack_public_path__ + "static/media/empty.41af0250.svg";